<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
  <div
    class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-22 sm:pt-12 sm:pb-28 sm:px-10 bg-default dark:bg-transparent"
  >
    <div class="flex-1 min-w-0">
      <div class="mt-2">
        <h2
          class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10"
        >
          Add Membership Profile
        </h2>
      </div>
    </div>
  </div>

  <div
    class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card"
    cdkScrollable
  >
    <form
      class="p-4 bg-card shadow rounded overflow-hidden"
      [formGroup]="horizontalStepperForm"
      (ngSubmit)="onFormSubmit()"
    >
      <mat-horizontal-stepper [linear]="true" #horizontalStepper>
        <!-- Step 1: Complete Profile -->
        <mat-step
          [formGroupName]="'step1'"
          [stepControl]="horizontalStepperForm?.get('step1')"
          #horizontalStepperStep1
        >
          <ng-template matStepLabel>Complete Profile</ng-template>
          <p class="hideText headingText">Parent Information</p>

          <div class="mainDiv">
            <mat-form-field class="flex-auto gt-xs:pr-3 items parent-info-form">
              <mat-label>Parent Full Name</mat-label>
              <input
                matInput
                formControlName="pgiFullName"
                (input)="onInputAlphabet($event)"
                placeholder="Full Name"
                (change)="parentNameChange($event)"
                required
                autocomplete="new-name"
              />
              <mat-error
                *ngIf="
                  horizontalStepperForm
                    ?.get('step1.pgiFullName')
                    ?.hasError('required')
                "
              >
                Please enter parent full name
              </mat-error>
            </mat-form-field>

            <mat-form-field class="flex-auto items parent-info-form">
              <mat-label>Email Address</mat-label>
              <input
                matInput
                formControlName="pgiEmail"
                placeholder="Email Address"
                required
                readonly
              />
              <mat-error
                *ngIf="
                  horizontalStepperForm
                    ?.get('step1.pgiEmail')
                    ?.hasError('required')
                "
              >
                Please enter email address
              </mat-error>
              <mat-error
                *ngIf="
                  horizontalStepperForm
                    ?.get('step1.pgiEmail')
                    ?.hasError('email')
                "
              >
                Please enter a valid email address
              </mat-error>
            </mat-form-field>
          </div>

          <div class="mainDiv">
            <mat-form-field class="flex-auto items parent-info-form">
              <mat-label>Primary Phone</mat-label>
              <input
                matInput
                formControlName="pgiHomePhone"
                (input)="onInputNumeric($event)"
                placeholder="Primary Phone"
                required
                autocomplete="new-number"
              />
              <mat-error
                *ngIf="
                  horizontalStepperForm
                    ?.get('step1.pgiHomePhone')
                    ?.hasError('required')
                "
              >
                Please enter primary phone
              </mat-error>
            </mat-form-field>

            <mat-form-field class="flex-auto items parent-info-form">
              <mat-label>City</mat-label>
              <input
                matInput
                formControlName="pgiCity"
                (input)="onInputAlphabet($event)"
                placeholder="City"
                required
                autocomplete="new-city"
              />
              <mat-error
                *ngIf="
                  horizontalStepperForm
                    ?.get('step1.pgiCity')
                    ?.hasError('required')
                "
              >
                Please enter City
              </mat-error>
            </mat-form-field>
          </div>

          <div class="mainDiv">
            <mat-form-field class="flex-auto gt-xs:pr-3 items parent-info-form">
              <mat-label>Community</mat-label>
              <mat-select
                formControlName="community"
                placeholder="Community"
                required
              >
                <mat-option
                  *ngFor="let list of userRecord?.lstLocations || []"
                  [value]="list.Id"
                >
                  {{ list.Name }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  horizontalStepperForm
                    ?.get('step1.community')
                    ?.hasError('required')
                "
              >
                Please select community
              </mat-error>
            </mat-form-field>
          </div>

          <div class="my-5 border-t"></div>
          <div class="flex justify-end">
            <button
              class="mt-4 px-8 py-2 space-x-4 bg-teal-900 text-white font-semibold rounded-full shadow-md hover:bg-teal-600 hover:scale-105 transition-all duration-300"
              mat-flat-button
              (click)="parentInfo()"
              [disabled]="!horizontalStepperForm?.get('step1')?.valid"
              type="button"
              matStepperNext
            >
              Next
            </button>
          </div>
        </mat-step>

        <!-- Step 2: Children Information -->
        <mat-step
          [formGroupName]="'step2'"
          [stepControl]="horizontalStepperForm?.get('step2')"
          #horizontalStepperStep2
        >
          <ng-template matStepLabel>Children Information</ng-template>
          <p class="hideText headingText">Children Information</p>

          <div class="flex flex-col gt-xs:flex-row">
            <div class="mainDiv">
              <mat-form-field
                class="flex-auto gt-xs:pr-3 items parent-info-form"
              >
                <mat-label>Child Full Name</mat-label>
                <input
                  placeholder="Full Name"
                  matInput
                  formControlName="fullName"
                  (input)="onInputAlphabet($event)"
                  (keyup)="checkChildName($event)"
                  required
                  autocomplete="new-child"
                />
                <mat-error
                  *ngIf="
                    horizontalStepperForm
                      ?.get('step2.fullName')
                      ?.hasError('required')
                  "
                >
                  Please enter name
                </mat-error>
                <mat-error
                  *ngIf="
                    horizontalStepperForm
                      ?.get('step2.fullName')
                      ?.hasError('forbiddenName')
                  "
                >
                  Child name must be different from parent name
                </mat-error>
              </mat-form-field>

              <mat-form-field class="flex-auto items parent-info-form">
                <mat-label>Gender</mat-label>
                <mat-select
                  formControlName="gender"
                  placeholder="Gender"
                  required
                >
                  <mat-option
                    *ngFor="let list of userRecord?.lstGenderPicklist || []"
                    [value]="list.key"
                  >
                    {{ list.value }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    horizontalStepperForm
                      ?.get('step2.gender')
                      ?.hasError('required')
                  "
                >
                  Please select gender
                </mat-error>
              </mat-form-field>
            </div>

            <div class="mainDiv">
              <mat-form-field
                class="flex-auto gt-xs:pr-3 items parent-info-form"
              >
                <mat-label>Choose a Date of Birth</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker"
                  [max]="todaysDate"
                  formControlName="dob"
                  (dateChange)="ageChange($event.value)"
                  placeholder="Choose a date of Birth"
                  required
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error>{{ getDobErrorMessage() }}</mat-error>
              </mat-form-field>

              <mat-form-field class="flex-auto items parent-info-form">
                <mat-label>Age</mat-label>
                <input
                  placeholder="Child Age"
                  maxlength="2"
                  matInput
                  formControlName="childAge"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>

          <br />
          <div class="flex justify-end">
            <button
              class="mt-4 px-8 py-2 space-x-4 bg-teal-900 text-white font-semibold rounded-full shadow-md hover:bg-teal-600 hover:scale-105 transition-all duration-300"
              mat-flat-button
              (click)="btnChildInfoClick()"
              [disabled]="!horizontalStepperForm?.get('step2')?.valid"
              type="button"
              matStepperNext
            >
              Next
            </button>
          </div>
        </mat-step>

        <!-- Step 3: Emergency Contacts -->
        <mat-step
          [formGroupName]="'step3'"
          [stepControl]="horizontalStepperForm?.get('step3')"
          #horizontalStepperStep3
        >
          <ng-template matStepLabel>Emergency Contacts</ng-template>
          <p class="hideText headingText">Emergency Contacts Information</p>

          <div class="flex flex-col gt-xs:flex-row">
            <div class="mainDiv1">
              <div *ngIf="imagePreviewEmergency">
                <img
                  [src]="imagePreviewEmergency"
                  alt="Emergency Image Preview"
                  class="profile-image"
                />
              </div>

              <div class="upload-container">
                <label for="fileUploadEmergency" class="font-bold">
                  Upload Emergency Contact Image
                </label>
                <input
                  type="file"
                  id="fileUploadEmergency"
                  (change)="onFileSelected($event, 'emergency')"
                  accept="image/*"
                />
                <span class="font-bold">Image file size must be in KB</span>
              </div>

              <mat-error *ngIf="imageError">
                Image must be less than 1MB.
              </mat-error>
            </div>

            <br />

            <div class="mainDiv">
              <mat-form-field
                class="flex-auto gt-xs:pr-3 items parent-info-form"
              >
                <mat-label>Emergency Contact Full Name</mat-label>
                <input
                  placeholder="Emergency Contact Full Name"
                  matInput
                  formControlName="contactName"
                  (input)="onInputAlphabet($event)"
                  (keyup)="checkEmergencyName($event)"
                  required
                  autocomplete="new-emergency"
                />
                <mat-error
                  *ngIf="
                    horizontalStepperForm
                      ?.get('step3.contactName')
                      ?.hasError('forbiddenName')
                  "
                >
                  Emergency contact full name must be different from parent name
                </mat-error>
              </mat-form-field>

              <mat-form-field class="flex-auto items parent-info-form">
                <mat-label>Primary Phone</mat-label>
                <input
                  placeholder="Primary Phone"
                  matInput
                  formControlName="homePhone"
                  required
                  (input)="onInputNumeric($event)"
                  autocomplete="new-emergency-number"
                />
              </mat-form-field>
            </div>

            <div class="w-full">
              <div class="mainDiv" id="agreement">
                <mat-checkbox
                  color="primary"
                  formControlName="canPickChild"
                  class="font-medium"
                >
                  This individual has permission to pick up children.
                </mat-checkbox>
              </div>
            </div>
          </div>

          <div class="flex justify-end">
            <button
              class="px-8 mt-4 py-2 space-x-4 bg-teal-900 text-white font-semibold rounded-full shadow-md hover:bg-teal-600 hover:scale-105 transition-all duration-300"
              mat-flat-button
              [disabled]="!horizontalStepperForm?.get('step3')?.valid"
              (click)="btnEmergencyContactClick()"
              type="button"
              matStepperNext
            >
              Next
            </button>
          </div>
        </mat-step>

        <!-- Step 4: Submit Membership -->
        <mat-step
          [formGroupName]="'step4'"
          [stepControl]="horizontalStepperForm?.get('step4')"
          #horizontalStepperStep4
        >
          <ng-template matStepLabel>Submit Membership</ng-template>
          <p class="hideText headingText">Submit Membership</p>

          <div class="flex flex-col gt-xs:flex-row">
            <div class="w-full">
              <div class="text-xl font-bold">
                General Waiver of Liability and Statements of Understanding
              </div>
            </div>

            <div class="my-5 border-t"></div>

            <div class="pb-6">
              <div [innerHTML]="waiverText"></div>
              <div *ngIf="waiverLastUpdate">
                <p class="font-bold mt-6">
                  Last Updated: {{ waiverLastUpdate }}
                </p>
              </div>
            </div>

            <div class="mainDiv mt-8">
              <mat-form-field
                class="flex-auto gt-xs:pr-3 items parent-info-form"
              >
                <mat-label>Waiver Signed by</mat-label>
                <input
                  placeholder="Full Name"
                  matInput
                  formControlName="liabilityIName"
                  (input)="onInputAlphabet($event)"
                  required
                />
                <mat-error
                  *ngIf="
                    horizontalStepperForm
                      ?.get('step4.liabilityIName')
                      ?.hasError('required')
                  "
                >
                  Please enter full Name
                </mat-error>
              </mat-form-field>

              <mat-form-field
                class="flex-auto gt-xs:pr-3 items parent-info-form"
              >
                <mat-label>City</mat-label>
                <input
                  placeholder="City"
                  matInput
                  formControlName="liabilityOfName"
                  required
                  autocomplete="new-city-step4"
                />
                <mat-error
                  *ngIf="
                    horizontalStepperForm
                      ?.get('step4.liabilityOfName')
                      ?.hasError('required')
                  "
                >
                  Please enter city
                </mat-error>
              </mat-form-field>
            </div>

            <div class="mainDiv">
              <mat-form-field
                class="flex-auto gt-xs:pr-3 items parent-info-form"
              >
                <mat-label>Signature Date</mat-label>
                <input
                  placeholder="Signature Date"
                  matInput
                  formControlName="liabilityDate"
                  required
                  disabled
                />
              </mat-form-field>

              <mat-form-field
                class="flex-auto gt-xs:pr-3 items parent-info-form"
              >
                <mat-label>Parent Signature (Print Full Name)</mat-label>
                <input
                  placeholder="Parent Signature"
                  matInput
                  formControlName="liabilityParentSignature"
                  (input)="onInputAlphabet($event)"
                  required
                  autocomplete="new-signature"
                />
                <mat-error
                  *ngIf="
                    horizontalStepperForm
                      ?.get('step4.liabilityParentSignature')
                      ?.hasError('required')
                  "
                >
                  Parent signature is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex justify-end">
            <button
              class="px-8 mr-2 bg-teal-600 text-white font-semibold rounded-full shadow-md hover:bg-teal-900 hover:scale-105 transition-all duration-300"
              mat-flat-button
              color="accent"
              type="button"
              matStepperPrevious
            >
              Back
            </button>
            <button
              class="px-8 ml-2 mr-2 submit-button"
              mat-raised-button
              color="primary"
              [disabled]="!horizontalStepperForm?.get('step4')?.valid"
              type="submit"
            >
              Submit
            </button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </form>

    <div class="loaderMain" *ngIf="pageLoader === true">
      <div>
        <img
          src="assets\TrailFusion\Trail-Fusion-logo.jpg"
          class="LoaderImage"
        />
        <p class="loaderText">{{ pageLoaderText }}</p>
      </div>
    </div>
  </div>
</div>
